// backend/src/contexts/ThemeContext.jsx

import React, { createContext, useContext } from 'react'
import useDarkMode from '../hooks/useDarkMode'

const ThemeContext = createContext({
  isDark: false,
  toggle: () => { },
  mounted: false,
})

export function ThemeProvider({ children }) {
  const [isDark, toggle, mounted] = useDarkMode()
  return (
    <ThemeContext.Provider value={{ isDark, toggle, mounted }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  return useContext(ThemeContext)
}
